import React from 'react';
import { BaseIcon } from './baseIcon';

export const X = () => (
  <BaseIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="24" fill="none" width="24">
    <g id="twitter">
      <path
        d="M17.9636 4H20.8769L14.512 11.2011L22 21H16.1368L11.5448 15.0569L6.29045 21H3.37514L10.183 13.2977L3 4H9.01168L13.1626 9.43208L17.9636 4ZM16.941 19.2738H18.5554L8.13456 5.63561H6.4023L16.941 19.2738Z"
        fill="white"
        id="icon"
      />
    </g>
  </BaseIcon>
);
